import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';
import router from './services/Routing';
import {
  SCROLLING_ROUTES,
  stopHeaderScroll,
  startHeaderScroll,
  headerScrollListener,
} from './services/utils';

router.beforeEach((to, from, next) => {
  window.document.title = to.name;
  window.scrollTo(0, 0);

  if (SCROLLING_ROUTES.includes(to.name)) {
    startHeaderScroll(headerScrollListener);
  } else {
    stopHeaderScroll(headerScrollListener);
  }

  next();
});

Vue.use(VueRouter);

/* eslint-disable no-new */
new Vue({ ...App, router }).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js